var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShareCommentEdit = function SvgIconShareCommentEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#icon_share_comment_edit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.872 6.617v6.709a1.167 1.167 0 0 1-1.166 1.166h-8.75a1.167 1.167 0 0 1-1.167-1.167V3.41a1.167 1.167 0 0 1 1.167-1.167h7.583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.969 8.545-2.063.825.825-2.063 5.363-5.362 1.237 1.238z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.331 3.183-1.237-1.237.618-.62a.875.875 0 1 1 1.238 1.239z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_share_comment_edit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.781h14v14H.5z"
  })))));
};
export default SvgIconShareCommentEdit;